module.exports = __webpack_public_path__ + "img/map-pin.4b84f521.svg";